import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncateMiddle',
  standalone: true,
})
export class TruncateMiddlePipe implements PipeTransform {
  transform(value: string | null | undefined, maxLength = 30): string {
    if (!value || value.length <= maxLength) return value ?? '';
    const keep = Math.floor((maxLength - 3) / 2);
    return `${value.slice(0, keep)}...${value.slice(value.length - keep)}`;
  }
}
